import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Button, IconButton } from '@material-ui/core'
import { Field } from 'redux-form'
import { COLORES } from '../../../../config/colores'
import CancelIcon from '@material-ui/icons/Cancel'
import { renderRadioField, renderTextField } from '../../../Forms/fieldRenderers'
import KeyboardIcon from '@material-ui/icons/Keyboard'

const PLANTAS_HABITUALES = [
  { fieldName: 'RENOVA', name: 'RENOVA' },
  { fieldName: 'TAYA 3 QUEQUEN', name: 'TAYA 3 QUEQUEN' }
]

function CampoPlantaRemito (props) {
  const { planta, setShowOtraPlanta } = props
  const [show, setShow] = useState(false)
  const [plantaSelected, setPlantaSelected] = useState(planta)
  const [nuevaPlanta, setNuevaPlanta] = useState(false)

  useEffect(() => {
    let existe = false
    PLANTAS_HABITUALES.map((p) => {
      if (p.name === planta) {
        existe = true
        setShowOtraPlanta(false)
      }
      return existe
    })
    setNuevaPlanta(!existe)
    if (planta !== plantaSelected) {
      setPlantaSelected(planta)
    }
  }, [setNuevaPlanta, setPlantaSelected, planta, plantaSelected, setShowOtraPlanta])

  const ocultarOtraPlanta = () => {
    props.resetPlanta()
    setShow(false)
  }

  const ingresarOtraPlanta = () => {
    props.setShowOtraPlanta(true)
    setShow(true)
  }

  return (
    <Row style={{ margin: '3% auto 0 auto', width: '100%' }}>
      <Col
        md={7}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'baseline',
          margin: '1.5% auto',
          paddingLeft: 0
        }}
      >
        <Field
          name='planta'
          className='radio-field'
          options={PLANTAS_HABITUALES}
          value={plantaSelected}
          component={renderRadioField}
        />

        { planta && nuevaPlanta &&
        <div
          style={{
            backgroundColor: '#6c757d',
            padding: '8px',
            borderRadius: '8px',
            fontWeight: 'bold',
            color: 'white'
          }}
        >
          {planta}
        </div>
        }
      </Col>
      { !show &&
        <>
          <Col md={1} />
          <Col md={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Button
              size='small'
              className='btn-nueva-planta'
              style={{ color: COLORES.grey.dark }}
              onClick={ingresarOtraPlanta}
              disabled={show}
            >
                              Ingresar otra planta
              <KeyboardIcon style={{ color: COLORES.grey.dark, margin: '0 2%', outline: 'none' }} />
            </Button>
          </Col>
        </>
      }

      {show &&
      <Col
        md={5}
        className='campos-remito-planta'
      >
        <Field
          name='planta'
          type='text'
          label='Ingrese el nombre de planta'
          component={renderTextField}
          autoFocus
          upperCase
        />

        <IconButton onClick={ocultarOtraPlanta} style={{ outlined: 'none' }}>
          <CancelIcon style={{ color: COLORES.grey.medium }} />
        </IconButton>
      </Col>
      }
    </Row>
  )
}

export default CampoPlantaRemito
